<template>
  <div
    class="cf-card cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-16 cf-cursor-pointer"
    @click="categoryCardClickHandler"
  >
    <img
      v-if="categoryImage"
      class="cf-image cf-image--thumbnail cf-image--thumbnail--large"
      :src="categoryImage"
      alt="category image"
      onerror="this.src='/images/image-not-found.png';"
    >

    <h2 class="cf-title cf-title--3 cf-no-wrap-ellipsis">
      {{ category.displayName }}
    </h2>
  </div>
</template>


<script>
  export default {
    name: 'CfMenuListCategoryCard',

    props: {
      category: {
        type: Object,
        required: true
      },

      categoryIndex: {
        type: Number,
        required: true
      }
    },

    computed: {
      categoryImage() {
        return this.category.images?.length
          ? this.category.images.find(image => image.label === 'kiosk')?.url
          : null;
      }
    },

    methods: {
      categoryCardClickHandler() {
        this.$emit('category-card-click-handler', { category: this.category, categoryIndex: this.categoryIndex });
      }
    }
  };
</script>
